import styled from '@emotion/styled';
import color from '@/styles/mobile/color';
import { Typography } from '@mui/material';

const uiColor = color.ui;

export const MainText = styled(Typography)`
  font-size: 4.4vw;
  line-height: 6.2vw;
  color: ${uiColor.textPrimary};
  @media (orientation: landscape) {
    font-size: 2.2vw;
    line-height: 3vw;
  }
`;

export const SecondaryText = styled(Typography)`
  font-size: 3.6vw;
  line-height: 5vw;
  color: ${(props) => props.color || uiColor.textSecondary};
  @media (orientation: landscape) {
    font-size: 1.8vw;
    line-height: 2.5vw;
  }
`;
